import { render, staticRenderFns } from "./team-message-button.vue?vue&type=template&id=510d042c"
import script from "./team-message-button.vue?vue&type=script&lang=js"
export * from "./team-message-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports